import * as R from 'ramda';

export const getRequestPayload = data => ({
  eligibilityRules: R.prop('populations', data),
});

export default {
  getRequestPayload,
};
